import { formatDate } from '@/utils/utils'

const state = {
  page: 1,
  total: 0,
  limit: 15,
  QQ: '',
  date: [],
  name: '',
  phone: '',
  username: '',
  unit_name: '',
  created_at_from: null,
  created_at_to: null,
  sort_name: null,
  sort: null
}

const actions = {
  // 获取数据
  async teacherManageGetData({ commit, state, rootState }) {
    const unit_id = localStorage.getItem('role_id')
    const page = state.page
    if (unit_id === '40001') {
      const data = {
        created_at_from:
          state.created_at_from && formatDate(state.created_at_from, 'U'),
        created_at_to:
          state.created_at_to && formatDate(state.created_at_to, 'U'),
        unit_name: state.unit_name,
        name: state.name,
        sort_name: state.sort_name,
        sort: state.sort,
        language: rootState.locale
      }
      Object.keys(data).forEach(key => {
        if (!data[key]) {
          delete data[key]
        }
      })
      const res = await API.get(
        `/edu/zone/channel/agent/teachers?page=${page}`,
        data
      )
      commit('setState', {
        module: 'teacherManage',
        key: 'total',
        value: res.data.total
      })
      return res
    } else {
      const data = {
        created_at_from:
          state.created_at_from && formatDate(state.created_at_from, 'U'),
        created_at_to:
          state.created_at_to && formatDate(state.created_at_to, 'U'),
        qq: state.QQ,
        name: state.name,
        phone: state.phone,
        username: state.username,
        sort_name: state.sort_name,
        sort: state.sort
      }
      Object.keys(data).forEach(key => {
        if (!data[key]) {
          delete data[key]
        }
      })
      const res = await API.get(`/edu/zone/teachers?page=${page}`, data)
      commit('setState', {
        module: 'teacherManage',
        key: 'total',
        value: res.data.total
      })
      return res
    }
  },
  // 恢复教师权限
  async teacherManageResume({ commit }, id) {
    const res = await API.patch(`/edu/zone/teacher/privilege/resume/${id}`)
    return res
  },
  // 取消教师权限
  async teacherManageCancel({ commit }, id) {
    const res = await API.patch(`/edu/zone/teacher/privilege/cancel/${id}`)
    return res
  },
  // 导出教师列表
  async teacherManageExcel({ commit, state, rootState }) {
    const data = {
      created_at_from:
        state.created_at_from && formatDate(state.created_at_from, 'U'),
      created_at_to:
        state.created_at_to &&
        formatDate(+new Date(state.created_at_to) / 1000 + 24 * 60 * 60, 'U'),
      qq: state.QQ,
      name: state.name,
      phone: state.phone,
      username: state.username,
      language: rootState.locale
    }
    Object.keys(data).forEach(key => {
      if (!data[key]) {
        delete data[key]
      }
    })
    const res = await API.get('/edu/zone/teachers/excel', data, {
      responseType: 'arraybuffer',
      timeout: 0
    })
    return res
  }
}

const mutations = {
  teacherManageInit(state) {
    state.page = 1
    state.QQ = ''
    // state.date = [];
    state.name = ''
    state.username = ''
    state.phone = ''
    state.unit_name = ''
    state.created_at_from = null
    state.created_at_to = null
  }
}

export default {
  state,
  actions,
  mutations
}
